import { LocalTrack } from 'models/LocalTrack';
import {
  FindMatchThreshold,
  MappingAutoMatchThreshold,
  MappingAutoMatchThresholdValue,
} from 'models/Mapping';
import { Track } from 'models/Track';
import { TrackRequest, TrackRequestType } from 'models/TrackRequest';
import { requestHash } from 'utils/requestHash';
import { useLocalDatabase } from './useLocalDatabase';

export function useTrackMapping() {
  const { localDatabase } = useLocalDatabase();

  const getMappedTrack = async (request: TrackRequest): Promise<LocalTrack | null> => {
    if (request.localId != null) {
      return localDatabase?.getTrackById(request.localId);
    }

    const mappingHash =
      request.type === TrackRequestType.Track
        ? await requestHash((request.value as Track).title, (request.value as Track).artist)
        : await requestHash(request.value as string);

    const mappingRef = await localDatabase?.getMapping(mappingHash);

    if (mappingRef !== undefined) {
      return localDatabase?.getTrackById(mappingRef.localId);
    }

    return null;
  };

  const getMappingAutoMatchThresholdValue = (threshold: MappingAutoMatchThreshold) => {
    if (!MappingAutoMatchThresholdValue[threshold]) {
      return MappingAutoMatchThresholdValue[MappingAutoMatchThreshold.Medium];
    }

    return MappingAutoMatchThresholdValue[threshold];
  };

  const getFindMatchThreshold = () => {
    return FindMatchThreshold;
  };

  return {
    getMappedTrack,
    getMappingAutoMatchThresholdValue,
    getFindMatchThreshold,
  };
}
